<template>
  <div class="upload__picture">
    <el-upload
      :class="{
        'avatar-uploader': type === 'avatar',
        'hide-upload-icon': !uploadAble
      }"
      ref="upload"
      action=""
      :headers="uploadProps.headers"
      :http-request="fnUploadRequest"
      v-bind="$_attrs"
    >
      <div v-if="type === 'avatar'">
        <img v-if="fileList && fileList.length" :src="fileList[0].url" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </div>
      <i v-else-if="type === 'picture'" class="el-icon-plus"></i>
      <slot v-else></slot>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '@/utils/token.js'
import { uploadOSS } from '@/utils/oss'

export default {
  name: 'OssUpload',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: '' // avatar 上传头像、 picture 照片墙
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.isSetValue) {
          return (this.isSetValue = false)
        }
        if (newVal && newVal instanceof Array && newVal.length) {
          this.fileList = newVal.map((item, index) => {
            if (item.url) {
              return {
                id: index + '',
                name: item.url.split('/')[item.url.split('/').length - 1],
                url: item.url
              }
            } else {
              return {
                id: index + '',
                name: item.split('/')[item.split('/').length - 1],
                url: item
              }
            }
          })
        } else {
          this.fileList = []
        }
      }
    }
  },
  computed: {
    $_attrs() {
      const { listType } = this.$attrs
      return {
        'file-list': this.fileList,
        'on-remove': this.remove,
        multiple: true,
        'list-type': listType ? listType : this.type === 'picture' ? 'picture-card' : 'picture',
        ...this.$attrs
      }
    },
    uploadProps() {
      return {
        headers: {
          Authorization: getToken()
        },
        data: {}
      }
    },
    uploadAble() {
      const { disabled, value, limit } = this.$_attrs
      if (disabled) return false
      if (!limit) return true
      if (!value || !value.length) return true
      return value.length < limit
    }
  },
  methods: {
    remove(file) {
      let num = this.fileList.findIndex((l) => l.id === file.id)
      if (num !== -1) {
        this.fileList.splice(num, 1)
        this.$emit('input', this.fileList)
      }
    },
    setValue(file) {
      if (this.type === 'avatar') {
        this.fileList = [file]
      } else {
        let num = this.fileList.findIndex((l) => l.id === file.id)
        if (num === -1) {
          this.fileList.push(file)
        } else {
          this.fileList.splice(num, 1)
          this.fileList.push(file)
        }
      }
      this.isSetValue = true
      this.$emit('input', this.fileList)
    },
    async fnUploadRequest(options) {
      try {
        let file = options.file
        let res = await uploadOSS(file)
        this.setValue(res)
        this.$message.success('上传成功！')
      } catch (e) {
        this.$message.error('上传失败！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload__picture {
  line-height: 1;
  .el-upload--picture-card {
    margin: 0 8px 8px 0;
  }
  ::v-deep .hide-upload-icon {
    .el-upload__tip,
    .el-upload--picture-card {
      display: none;
    }
  }
}
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/OssUpload/index.vue